module.exports = __webpack_public_path__ + "static/media/construction.e863ec03.svg";